module.exports = __webpack_public_path__ + "img/embedded_w.12201c51.svg";